import { jsx as _jsx } from "react/jsx-runtime";
import { Link as BaseLink } from 'react-router-dom';
import { usePathPrefix } from '@src/hooks/usePathPrefix';
export default function Link({ to, children, ...props }) {
    const prefix = usePathPrefix();
    return (_jsx(BaseLink, { to: `/${prefix}${to}`, ...props, children: children }));
}
